module.exports = __webpack_public_path__ + "img/20191211163246646.aaa6e21f.jpg";